module.exports = __webpack_public_path__ + "static/img/a1.f364524.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/a1.jpg
// module id = /mI1
// module chunks = 4